import { Customer } from '@api/Trinium/Endpoints/Customer/types';
import { GridColDef } from '@mui/x-data-grid-pro';
import RenderHeader from '../RenderHeader';
import StackedTextCell from '../ColumnDefinitions/StackedTextCell';
import MonetaryAmountCell from '../ColumnDefinitions/MonetaryAmountCell';
import { caseInsensitiveIncludes } from '../Dispatch/columns';
import CustomerMobileListItem from './MobileListItem';

import gridStyles from '../RenderCell.module.css';

export const customerColumnDefinitions: GridColDef<Customer>[] = [
	{
		field: 'id',
		renderHeader: () => (
			<RenderHeader
				primaryText='Customer Name'
				secondaryText='Code'
			/>
		),
		renderCell: ({ row }) => (
			<StackedTextCell
				primaryText={row.name}
				primaryClassName={gridStyles['customer-name-col']}
				secondaryText={row.id}
			/>
		),
		flex: 1,
		minWidth: 120,
		cellClassName: gridStyles.cell,
		sortable: false,
		disableColumnMenu: true,
		disableReorder: true,
		filterable: true,
		getApplyQuickFilterFn: (value: string) => {
			return (_, row): boolean => caseInsensitiveIncludes(value, [row.id, row.name]);
		}
	},
	{
		field: 'availCredit',
		renderHeader: () => <RenderHeader primaryText='Avail. Credit' />,
		renderCell: ({ row }) => <MonetaryAmountCell value={row.availCredit} />
	},
	{
		field: 'address',
		renderHeader: () => (
			<RenderHeader
				primaryText='Address 1'
				secondaryText='Address 2'
			/>
		),
		renderCell: ({ row }) => (
			<StackedTextCell
				primaryText={row.addr1}
				secondaryText={row.addr2}
			/>
		),
		flex: 1,
		minWidth: 150,
		cellClassName: gridStyles.cell,
		sortable: false,
		disableColumnMenu: true,
		disableReorder: true
	},
	{
		field: 'citystate',
		renderHeader: () => (
			<RenderHeader
				primaryText='City'
				secondaryText='State, Zip'
			/>
		),
		renderCell: ({ row }) => (
			<StackedTextCell
				primaryText={row.city}
				secondaryText={`${row.state ?? ''} ${row.zip ?? ''}`}
			/>
		),
		flex: 1,
		minWidth: 100,
		cellClassName: gridStyles.cell,
		sortable: false,
		disableColumnMenu: true,
		disableReorder: true
	},
	{
		field: 'contact',
		renderHeader: () => (
			<RenderHeader
				primaryText='Phone'
				secondaryText='Fax'
			/>
		),
		renderCell: ({ row }) => (
			<StackedTextCell
				primaryText={row.phone}
				secondaryText={row.fax}
			/>
		),
		minWidth: 100,
		cellClassName: gridStyles.cell,
		sortable: false,
		disableColumnMenu: true,
		disableReorder: true
	},
	{
		field: 'saleperson',
		renderHeader: () => <RenderHeader primaryText='Salesperson' />,
		renderCell: ({ row }) => <StackedTextCell primaryText={row.salesperson?.name} />,
		minWidth: 100,
		cellClassName: gridStyles.cell,
		sortable: false,
		disableColumnMenu: true,
		disableReorder: true
	}
];

export const mobileCustomerColumnDefinition: GridColDef<Customer>[] = [
	{
		field: 'MobileCard',
		display: 'flex',
		flex: 1,
		renderCell: CustomerMobileListItem,
		getApplyQuickFilterFn: (value: string) => {
			return (_, row): boolean => caseInsensitiveIncludes(value, [row.id, row.name]);
		}
	}
];
